/**
 * Source: docs/rules/05-essence.md
 *
 * Essence is the one purchase that spends Experience without adding to the
 * captain's Cost. That makes Cost and Experience-spent two different figures,
 * and both have to be shown or the totals look wrong.
 *
 * Deliberately minimal for now: the count is recorded and its Experience is
 * calculated, but nothing is validated against a budget. Whether Essence may
 * be bought during creation from an Experience Level's allowance -- as opposed
 * to only from Experience earned in play -- is not settled by the rules
 * document. The Total XP / Essence Used ledger described in that document's
 * notes waits on advancement rules, which do not exist yet.
 */

export const ESSENCE_COST = 5;

export function essenceCostFor(points: number): number {
  return points * ESSENCE_COST;
}
